// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICardHolderCardDto
 */
export interface ICardHolderCardDto {
    /**
     * 
     * @type {number}
     * @memberof ICardHolderCardDto
     */
    card_holder_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ICardHolderCardDto
     */
    card_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof ICardHolderCardDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICardHolderCardDto
     */
    valid_to?: Date;
    /**
     * 
     * @type {number}
     * @memberof ICardHolderCardDto
     */
    member_sequence_identifier?: number;
    /**
     * 
     * @type {string}
     * @memberof ICardHolderCardDto
     */
    status?: ICardHolderCardDtoStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum ICardHolderCardDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    CLOSED = 'CLOSED',
    PENDING_CLOSED = 'PENDING_CLOSED',
    FROZEN = 'FROZEN',
    LOST = 'LOST',
    PENDING_OPEN = 'PENDING_OPEN',
    PENDING_FROZEN = 'PENDING_FROZEN',
    PENDING_REPLACE = 'PENDING_REPLACE',
    STOLEN = 'STOLEN',
    NOT_SENT = 'NOT_SENT',
    PENDING_UNLOCK = 'PENDING_UNLOCK',
    DAMAGED = 'DAMAGED',
    CLOSING = 'CLOSING',
    DEMOGRAPHIC_CHANGE = 'DEMOGRAPHIC_CHANGE'
}


/**
 * Check if a given object implements the ICardHolderCardDto interface.
 */
export function instanceOfICardHolderCardDto(value: object): value is ICardHolderCardDto {
    return true;
}

export function ICardHolderCardDtoFromJSON(json: any): ICardHolderCardDto {
    return ICardHolderCardDtoFromJSONTyped(json, false);
}

export function ICardHolderCardDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICardHolderCardDto {
    if (json == null) {
        return json;
    }
    return {
        
        'card_holder_id': json['card_holder_id'] == null ? undefined : json['card_holder_id'],
        'card_id': json['card_id'] == null ? undefined : json['card_id'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
        'member_sequence_identifier': json['member_sequence_identifier'] == null ? undefined : json['member_sequence_identifier'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function ICardHolderCardDtoToJSON(json: any): ICardHolderCardDto {
    return ICardHolderCardDtoToJSONTyped(json, false);
}

export function ICardHolderCardDtoToJSONTyped(value?: ICardHolderCardDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'card_holder_id': value['card_holder_id'],
        'card_id': value['card_id'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString()),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString()),
        'member_sequence_identifier': value['member_sequence_identifier'],
        'status': value['status'],
    };
}

